export default {
    generateContentModal: {
        title: 'Generer Innhold',
        type: 'Type',
        typePlaceholder: 'Velg type',
        typeEmptyError: 'Vennligst velg en type',
        context: 'Kontekst',
        contextPlaceholder: 'Velg kontekst',
        contextEmptyError: 'Vennlisgt velg en kontekst',
        contentTitle: 'Innholdstittel',
        contentTitlePlaceholder: 'Legg til ett tema for innholdet ditt',
        contentTitleEmptyError: 'Vennligst skriv inn tittelen',
        contentTitleInvalidError: 'Vennligst skriv inn en gyldig tittel',
        description: 'Gi en kort innholdsbeskrivelse',
        descriptionPlaceholder: 'Legg til en beskrivelse av innholdet ditt med 2-3 setninger.',
        descriptionEmptyError: 'Vennligst skriv inn beskrivelsen',
        descriptionInvalidError: 'Vennligst skriv inn en gyldig beskrivelse',
        addKeywords: 'Legg til nøkkelord',
        addKeywordsEmptyError: 'Vennligst skriv inn nøkkelordene',
        writingTone: 'Skrivetone',
        writingTonePlaceholder: 'Velg skrivetone',
        writingToneEmptyError: 'Vennligst velg en skrivetone',
        numberOfVariations: 'Antall varianter',
        numberOfVariationsEmptyError: 'Vennligst velg antall varianter',
        numberOfVariationsInvalidError: 'Du kan generere fra 1 til 5 forskjellige varianter.',
        generate: 'Generere',
        additionalOptions: 'Ytterligere alternativer',
        clear: 'Tøm',
        writingToneOptions: {
            funny: 'Morsom',
            casual: 'Uformelt',
            excited: 'Begeistret',
            professional: 'Profesjonell',
            witty: 'Vittig',
            sarcastic: 'Sarkastisk',
            feminine: 'Feminin',
            masculine: 'Maskulin',
            bold: 'Modig',
            dramatic: 'Dramatisk',
            grumpy: 'Grinete',
            secretive: 'Hemmelighetsfull',
            respectful: 'Respektfull',
            persuasive: 'Overbevisende',
        },
        contextOptions: {
            promotional: 'Salgsfremmende',
            introduction: 'Introduksjon',
            couponDiscount: 'Kupong/Avslag',
            recurringNewsletter: 'Gjentagende Nyhetsbrev',
            testimonial: 'Attest',
            coldOutreach: 'Kald Oppsøkning',
            contentGiveaway: 'Innhold/Giveaway',
            other: 'Annen',
        },
        typeOptions: {
            outline: 'Disposisjon',
            introduction: 'Introduksjon',
            section: 'Seksjon',
        },
    },
};
